import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getExtraStorage } from '@custom/rtk-apis/Setting/extraStorage/getExtraStorage';

interface ExtraStorageState {
  result: any;
  loading: boolean;
  error: string | null;
  success: boolean;
  status: string | null;
}

const initialState: ExtraStorageState = {
  result: null,
  loading: false,
  error: null,
  success: false,
  status: null,
};

const getExtraStorageSlice = createSlice({
  name: 'getExtraStorage',
  initialState,
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
    },
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExtraStorage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getExtraStorage.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.result = action.payload;
        state.success = true;
        state.status = 'SUCCESS';
      })
      .addCase(getExtraStorage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
        state.status = 'FAILED';
      });
  },
});

export default getExtraStorageSlice.reducer;
export const { resetSuccess, resetError } = getExtraStorageSlice.actions;
